module.exports = __webpack_public_path__ + "e0106718/img/boston-lights.a623432f.png";